exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.card-header[data-v-18f964af] {\n  font-weight: bold;\n}\n.category-title[data-v-18f964af] {\n  width: 100%;\n  font-size: 1.2em;\n  text-align: center;\n  background-color: lightgrey;\n  font-weight: bold;\n}\n.vertical-center[data-v-18f964af] {\n  min-height: 100%;  /* Fallback for browsers do NOT support vh unit */\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n#accompanyingSheet .modal-body[data-v-18f964af] {\n  max-height: calc(100vh - 210px);\n  overflow-y: scroll;\n}\n#iscoButton[data-v-18f964af] {\n  max-width: 100%;\n  overflow: auto;\n  text-overflow: ellipsis;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-18f964af","scoped":true,"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./resources/js/components/AccompanyingSheet.vue
// module id = r3JO
// module chunks = 97